import { type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';
import { inMemoryCache } from '../../../utils/caching/in-memory';

const GQL_ASSETS_OBJECT_TYPES_NAME = 'SearchPageAssetsObjectTypesQuery';
const assetsObjectTypesQueryString = `query ${GQL_ASSETS_OBJECT_TYPES_NAME}(
	$objectTypeARIs: [ID!]!) {
		assets_objectTypesByIds(ids: $objectTypeARIs) {
    		id
    		name
    		sequentialId @optIn(to: "AssetsApFields")
    		icon {
      			url16
    		}
    		schema {
      			name
    		}
  		}
	}`;

export const assetsObjectTypesCache = inMemoryCache<AggResponse<AssetsObjectTypesResponse>>();

export type AssetsObjectTypesQueryVariables = {
	objectTypeARIs: string[];
};

export type AssetsObjectTypesResponse = {
	assets_objectTypesByIds: {
		id: string;
		name: string;
		sequentialId: string;
		icon: {
			url16: string;
		};
		schema: {
			name: string;
		};
	}[];
};

export const assetsObjectTypesQuery = async (objectTypeARIs: string[]) => {
	return assetsObjectTypesCache.inMemoryDecorator(`${objectTypeARIs}`, async () => {
		const response = await fetchAgg<AssetsObjectTypesQueryVariables, AssetsObjectTypesResponse>({
			graphQuery: assetsObjectTypesQueryString,
			variables: {
				objectTypeARIs,
			},
			operationName: GQL_ASSETS_OBJECT_TYPES_NAME,
			headers: {
				'X-ExperimentalApi': 'AssetsObjectTypes',
			},
		});

		const hasErrors = response.errors?.some((error) => error);

		if (hasErrors) {
			return Promise.reject(response);
		}

		return response;
	});
};
